
define('text!modules/360-feedback/states/360-feedback-external/template.html',[],function () { return '<div ui-view=feedback class="column / large-8 / medium-10 / small-12 small-centered" autoscroll></div>';});

